import { ORG_SEARCH_DEBOUNCE_MS } from '../SalesReport/constants'

export { ORG_SEARCH_DEBOUNCE_MS }

export const DEFAULT_ROWS_PER_PAGE = 10
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]
export const SEARCH_DEBOUNCE_MS = 400

export const COLUMN_COUNT = 10
